import {UserNotification} from '../models/user.model';

/**
 * Type of the record the API stores on a member when they dismiss a chapter notification banner
 * (NotificationController.dismiss). It is bookkeeping that keeps the banner from coming back, not something to read.
 */
export const DISMISSAL_RECORD_TYPE = 'CHAPTER_NOTIFICATION';

/** The notifications a member should see on their profile: everything except the dismissal records. */
export function visibleUserNotifications(notifications?: UserNotification[] | null): UserNotification[] {
    return (notifications || []).filter(n => n.type !== DISMISSAL_RECORD_TYPE);
}
